import { CloudMast } from "./CloudMast";

// Shown when a full run was accepted into the queue (all analysis slots were
// busy at submit). The run is committed server-side — the scheduler starts it
// when a slot frees, and the completion email carries the user back — so this
// screen's job is to reassure + release them from waiting, not to hold a tab.
//
// Reuses the shared landing chrome (no new CSS). Honest position, no countdown:
// we have no ETA signal, only how many queued runs are ahead.
//
// Wired into App.tsx's run phase machine as the `convert-queued` full-screen
// takeover (2026-06-24); App polls /status and swaps to the live run on
// promotion. See docs/topics/run-queue/spec.md §Frontend.
export function QueuedScreen({
  position,
}: {
  /** Queued runs ahead of this one (0 = next up). null/undefined → next in line. */
  position?: number | null;
}) {
  const ahead = typeof position === "number" && position > 0;
  return (
    <main className="landing">
      <div className="landing-wrap">
        <CloudMast />
        <section className="deeplink-body">
          <h1 className="landing-title">Your analysis is in line.</h1>
          <p className="landing-lede">
            Every analysis slot is busy right now, so we’ve queued yours — it
            starts automatically the moment one frees up.{" "}
            {ahead
              ? `${position} ${position === 1 ? "analysis is" : "analyses are"} ahead of you.`
              : "You’re next in line."}
          </p>
          <p className="landing-lede">
            You don’t have to wait here. Close this tab whenever you like — we’ll
            email you the moment your record is ready. Nothing is lost, and your
            code stays valid.
          </p>
        </section>
      </div>
    </main>
  );
}
